import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Workflow from './components/Workflow';
import AIProcess from './components/AIProcess';
import Comparison from './components/Comparison';
import WhyChooseUs from './components/WhyChooseUs';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import ChatIcon from './components/ChatIcon';
import ThankYou from './components/ThankYou';
import Demo from './components/Demo';
import UseCases from './components/UseCases';
import UseCaseDetail from './components/UseCaseDetail';
import './App.css';

function App() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <Hero onOpenChatbot={() => setIsChatbotOpen(true)} />
              <Services />
              <Workflow />
              <AIProcess />
              <Comparison />
              <WhyChooseUs />
              <CTA />
              {/* VoiceAssistantSection temporarily disabled */}
              <Contact />
              <Footer />

              <ChatIcon 
                onClick={toggleChatbot}
                isOpen={isChatbotOpen}
              />
              <Chatbot
                isOpen={isChatbotOpen}
                onClose={() => setIsChatbotOpen(false)}
              />
            </>
          } />
          <Route path="/demo" element={
            <>
              <Navbar />
              <Demo />
              <Footer />

              <ChatIcon 
                onClick={toggleChatbot}
                isOpen={isChatbotOpen}
              />
              <Chatbot
                isOpen={isChatbotOpen}
                onClose={() => setIsChatbotOpen(false)}
              />
            </>
          } />
          <Route path="/use-cases" element={
            <>
              <Navbar />
              <UseCases />
              <Footer />

              <ChatIcon 
                onClick={toggleChatbot}
                isOpen={isChatbotOpen}
              />
              <Chatbot
                isOpen={isChatbotOpen}
                onClose={() => setIsChatbotOpen(false)}
              />
            </>
          } />
          <Route path="/use-cases/:useCaseId" element={
            <>
              <Navbar />
              <UseCaseDetail />
              <Footer />

              <ChatIcon 
                onClick={toggleChatbot}
                isOpen={isChatbotOpen}
              />
              <Chatbot
                isOpen={isChatbotOpen}
                onClose={() => setIsChatbotOpen(false)}
              />
            </>
          } />
          <Route path="/thank-you" element={
            <>
              <Navbar />
              <ThankYou />
              <Footer />

              <ChatIcon 
                onClick={toggleChatbot}
                isOpen={isChatbotOpen}
              />
              <Chatbot
                isOpen={isChatbotOpen}
                onClose={() => setIsChatbotOpen(false)}
              />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
